import React, { useState } from 'react';

export const AgendaStreamingContext = React.createContext(13);

function AgendaStreamingContextProvider(props) {
    const [context, setContext] = useState({
        showAgendaStreaming: false,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        currentMatch:null,
        setCurrentMatch: function(currentMatch){
            this.update({currentMatch});
        },
        setShowAgendaStreaming: function(showAgendaStreaming) {
            this.update({showAgendaStreaming});
        }
    });

    return (
        <AgendaStreamingContext.Provider value={context}>
            {props.children}
        </AgendaStreamingContext.Provider>
    );
}

export default AgendaStreamingContextProvider;